import cn from "classnames";
import React from "react";
import { BaseControl } from "react-map-gl";
import type { MapControlProps } from "react-map-gl/src/components/use-map-control";
import BadgeImage from "../assets/images/kinderkiez-badge.svg";
import styles from "./BadgeOverlay.module.css";

interface Props extends MapControlProps {
  position?: "CENTER" | "RIGHT";
  inFrame?: boolean;
}

export class BadgeOverlay extends BaseControl<Props, HTMLDivElement> {
  _render() {
    const { position, inFrame } = this.props;
    return (
      <div
        ref={this._containerRef as unknown as React.LegacyRef<HTMLDivElement>}
        className={cn([
          styles.container,
          position === "RIGHT" && styles.rightAligned,
          inFrame && styles.bottom,
        ])}
      >
        <img className={styles.image} src={BadgeImage.src} alt="kinderkiez" />
      </div>
    );
  }
}
